import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import { MdImportExport, MdDeleteForever } from 'react-icons/md';

import Dialog from 'react-bootstrap-dialog';
// import Card from "react-bootstrap/Card";

import "react-table/react-table.css";
import "../css/style.css";
// import WorkerPlan from './WorkerPlan';

import {
  WO_EXPORTED_CK, WO_ASSIGNED_WORKER, WO_READY, WO_COMPLETED_CK, WO_NHAM, WO_BONG, WO_QUAYKIM, WO_XI, WO_VOBAO, WO_SHIP_FROMVN, WO_TOBE_FIXED, WO_KIEMTRA,
  DATA_TYPE_SUPERVISOR, DATA_TYPE_PRINT_TAIL, WO_CANCELLED, WO_TOBE_FIXE_LOIXI, WO_TOBE_FIXE_LOITHO, WO_TOBE_FIXE_ALL, LOI_THO_LIST, ERROR_CODE_LOI_XI, ERROR_CODE_LOI_XI_TRAY_DONG_GOI, LOI_CAT_KHAC_LIST, WO_TOBE_FIXE_LOI_CATKHAC, LOI_XI_LIST, ITEM_TYPE_LENDA, ITEM_TYPE_NONE
} from '../constants';

import MenuComponent2 from './MenuComponent2';
// import SuperListView from './SuperListView';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import NoteDataService from '../services/NoteDataService';
import { ICON_COLOR } from '../icon';
import queryString from 'query-string'
import UserDataService from '../services/UserDataService';
import { Multiselect } from 'multiselect-react-dropdown';
import ItemDataService from '../services/ItemDataService';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderAdditions from './WorkOrderAdditions';
import DataUtil from '../utilities/DataUtil';

class SuperList extends Component {
  constructor() {
    super();

    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000 * 3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      deadline: 0,
      loading: false,
      selected: {},
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      status: '0',
      assignOnly: '0',
      country: null,
      customer: null,
      orderNo: null,
      woStatus: 0,
      workOrders: [],
      childRefreshCount: 0,
      worker: [],
      selectedWorker: 0,
      workerName: '',
      woStatusList: [],
      selectedWoStatusList: [WO_EXPORTED_CK, WO_COMPLETED_CK, WO_ASSIGNED_WORKER, WO_READY],
      selectedWorkersToAssign: [],
      columns: [],
      show: false,
      workOrder: {},
      assignCount: 0,
      assignDate: undefined,
      notPrint: '0',
      notPrintTail: '0',
      notAssigned: '0',
      fromDeadlineDate: toDate,
      toDeadlineDate: toDate,
      pcode: '',
      personalization: '',
      sortBy: 'ID',
      sortType: 'desc',
      sku: '',
      size: '',

      deadline4U: 0,
      loading4U: false,
      selected4U: {},
      fromDate4U: fromDate,
      toDate4U: toDate,
      country4U: null,
      customer4U: null,
      orderNo4U: null,
      workOrders4U: [],
      selectedWorker4U: null,
      childRefreshCount4U: 0,
      woStatusList4U: [],
      selectedWoStatusList4U: [],
      workOrder4U: {},
      notPrint4U: '0',
      fromDeadlineDate4U: toDate,
      toDeadlineDate4U: toDate,
      pcode4U: '',
      personalization4U: '',
      sortBy4U: 'ID',
      sortType4U: 'desc',
      woSubStatus: 0,
      errorFilter: 0
    };
  }

  handleEdit(e) {
    this.showWorkOrdersByNo(e.original.workOrderNo);
  }

  linkToDetails(row) {
    return (
      <label className="label_link" href="#!" onClick={() => { this.handleEdit(row) }}>{row.original.workOrderNo}</label>
    )
  }
  onSelect(selectedList, selectedItem) {
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  onRemove(selectedList, removedItem) {
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  onSelectWorker(selectedList, selectedItem) {
    this.setState({
      selectedWorkersToAssign: selectedList
    });
  }

  onRemoveWorker(selectedList, removedItem) {
    this.setState({
      selectedWorkersToAssign: selectedList
    });
  }

  onSelect4U(selectedList, selectedItem) {
    this.setState({
      selectedWoStatusList4U: selectedList
    });
  }

  onRemove4U(selectedList, removedItem) {
    this.setState({
      selectedWoStatusList4U: selectedList
    });
  }

  loadItems() {
    ItemDataService.retrieveItems().then(data => {
      this.setState({
        items: data
      });
    });
  }

  loadWorker() {
    if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isKhac() || AuthenticationService.isSupervisor()) {
      UserDataService.retrieveWorkers().then(data => {
        let len = data.length;
        let worker = [];
        for (let i = 0; i < len; i++) {
          worker.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: data[i].userName })
        }
        this.setState({ worker: worker });
      });
    }
  }

  componentDidMount() {

    MasterDataService.retrieveAllStatus().then(data => {
      let woDefaultStatusList = [
        { id: WO_EXPORTED_CK, name: WorkOrderUtil.getStatusDescription(data, WO_EXPORTED_CK) },
        { id: WO_ASSIGNED_WORKER, name: WorkOrderUtil.getStatusDescription(data, WO_ASSIGNED_WORKER) },
        { id: WO_READY, name: WorkOrderUtil.getStatusDescription(data, WO_READY) },
        { id: WO_COMPLETED_CK, name: WorkOrderUtil.getStatusDescription(data, WO_COMPLETED_CK) },
      ];

      let fromDate = WorkOrderUtil.getItem("supervext.fromDate")
      let toDate = WorkOrderUtil.getItem("supervext.toDate")
      let assignDate = WorkOrderUtil.getItem("supervext.assignDate")

      const values = queryString.parse(this.props.location.search);
      let numOfMonths = 12;
      if (values !== undefined && values.status !== undefined) {
        numOfMonths = 24;
      }

      if (values === undefined || (values.status === undefined && values.isback === undefined)) {
        WorkOrderUtil.removeItem('supervext.woStatus');
      }

      if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
        let backTime = 30 * 24 * 60 * 60 * 1000 * numOfMonths;
        fromDate = new Date(new Date().getTime() - backTime);//1 month
        fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
      }

      if (toDate === null || toDate === undefined) {
        toDate = new Date();
        toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
      }

      let swoStatusList = WorkOrderUtil.getItem('supervext.selectedWoStatusList');
      let woStatusList = [];
      if (swoStatusList === null || swoStatusList === undefined || swoStatusList.length < 10){
        woStatusList = woDefaultStatusList;
      } else {
        try {
          woStatusList = JSON.parse(swoStatusList)
        } catch (ec) {
          woStatusList = woDefaultStatusList;
        }
      }

      console.log('woStatusList', woStatusList);

      let semi = WorkOrderUtil.getItem("supervext.semi");
      let ignoreSemi = '1';

      if (semi == 0 || semi == 1) {
        ignoreSemi = '-1';
      }

      let reprintTail = WorkOrderUtil.getItem("supervext.reprintTail");


      let byDeadline = WorkOrderUtil.getItem('supervext.byDeadline');
      let fromDeadlineDate = WorkOrderUtil.getItem('supervext.fromDeadlineDate');
      let toDeadlineDate = WorkOrderUtil.getItem('supervext.toDeadlineDate');
      let deadline = WorkOrderUtil.getItem('supervext.deadline') ? WorkOrderUtil.getItem('supervext.deadline') : '0';
      let pcode = WorkOrderUtil.getItem('supervext.pcode') ? WorkOrderUtil.getItem('supervext.pcode') : '';
      let personalization = WorkOrderUtil.getItem('supervext.personalization') ? WorkOrderUtil.getItem('supervext.personalization') : '';
      let sortBy = WorkOrderUtil.getItem('supervext.sortBy') ? WorkOrderUtil.getItem('supervext.sortBy') : 'ID';
      let sortType = WorkOrderUtil.getItem('supervext.sortBy') ? WorkOrderUtil.getItem('supervext.sortType') : 'desc';
      let sku = WorkOrderUtil.getItem('supervext.sku');
      let size = WorkOrderUtil.getItem('supervext.size');
      let notPrintTail = WorkOrderUtil.getItem('supervext.notPrintTail');
      let notAssigned = WorkOrderUtil.getItem('supervext.notAssigned');
      let incident = WorkOrderUtil.getItem('supervext.incident');
      //let woSubStatus = WorkOrderUtil.getItem('supervext.woSubStatus');

      let errorFilter =  WorkOrderUtil.getItem('supervext.errorFilter') === null || WorkOrderUtil.getItem('supervext.errorFilter') === undefined? 0: parseInt(WorkOrderUtil.getItem('supervext.errorFilter'));
      let woSubStatus =  WorkOrderUtil.getItem('supervext.woSubStatus') === null || WorkOrderUtil.getItem('supervext.woSubStatus') === undefined? 0: parseInt(WorkOrderUtil.getItem('supervext.woSubStatus'));
      let includeMau = WorkOrderUtil.getItem("prod.includeMau");

      this.setState({
        fromDate: fromDate,
        toDate: toDate,
        assignDate: assignDate,
        orderNo: WorkOrderUtil.getItem("supervext.orderNo"),
        woStatus: WorkOrderUtil.getItem("supervext.woStatus") ? WorkOrderUtil.getItem("supervext.woStatus") : 0,
        workerName: WorkOrderUtil.getItem("supervext.workerName") ? WorkOrderUtil.getItem("supervext.workerName") : '',
        selectedWoStatusList: woStatusList,
        semi: semi,
        ignoreSemi: ignoreSemi,
        byDeadline: byDeadline,
        fromDeadlineDate: fromDeadlineDate,
        toDeadlineDate: toDeadlineDate,
        deadline: deadline,
        pcode: pcode,
        personalization: personalization,
        sortBy: sortBy,
        sortType: sortType,
        reprintTail: reprintTail,
        sku: sku,
        size: size,
        notPrintTail: notPrintTail,
        notAssigned: notAssigned,
        incident: incident,
        woSubStatus: woSubStatus,
        errorFilter: errorFilter,
        includeMau: includeMau
      }, () => {
        const query = queryString.parse(this.props.location.search);
        if (query.caller !== '0') { //Clicked on NAV
          this.filterOrdersBy();
        } else {
          this.setState({ loading: false });
        }
      });
      this.setState({
        allStatus: data,
        //WO_EXPORTED_CK, WO_ASSIGNED_WORKER, WO_READY, WO_COMPLETED_CK, WO_NHAM, WO_BONG, WO_QUAYKIM, WO_XI, WO_VOBAO, WO_SHIP_FROMVN, WO_TOBE_FIXED, WO_KIEMTRA, WO_CANCELLED
        woStatusList: [
          { id: WO_EXPORTED_CK, name: WorkOrderUtil.getStatusDescription(data, WO_EXPORTED_CK) },
          { id: WO_ASSIGNED_WORKER, name: WorkOrderUtil.getStatusDescription(data, WO_ASSIGNED_WORKER) },
          { id: WO_READY, name: WorkOrderUtil.getStatusDescription(data, WO_READY) },
          { id: WO_COMPLETED_CK, name: WorkOrderUtil.getStatusDescription(data, WO_COMPLETED_CK) },
          { id: WO_NHAM, name: WorkOrderUtil.getStatusDescription(data, WO_NHAM) },
          { id: WO_BONG, name: WorkOrderUtil.getStatusDescription(data, WO_BONG) },
          { id: WO_QUAYKIM, name: WorkOrderUtil.getStatusDescription(data, WO_QUAYKIM) },
          { id: WO_XI, name: WorkOrderUtil.getStatusDescription(data, WO_XI) },
          { id: WO_VOBAO, name: WorkOrderUtil.getStatusDescription(data, WO_VOBAO) },
          { id: WO_SHIP_FROMVN, name: WorkOrderUtil.getStatusDescription(data, WO_SHIP_FROMVN) },
          { id: WO_TOBE_FIXED, name: WorkOrderUtil.getStatusDescription(data, WO_TOBE_FIXED) },
          { id: WO_KIEMTRA, name: WorkOrderUtil.getStatusDescription(data, WO_KIEMTRA) },
          { id: WO_CANCELLED, name: WorkOrderUtil.getStatusDescription(data, WO_CANCELLED) },
        ],
        columns: [
          {
            id: "idx",
            accessor: "",
            width: 40,
            Cell: row => (
              <div style={{ padding: "10px" }}>{row.index + 1}</div>
            )
          },
          {
            id: "checkbox",
            accessor: "",
            Cell: ({ original }) => {
              return (
                <div style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={this.state.selected[original.id] && this.state.selected[original.id].checked === true? true : false}
                    onChange={() => this.toggleRow(original)}
                  /></div>
              );
            },
            Header: x => {
              return (
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selectAll === 1}
                  ref={input => {
                    if (input) {
                      input.indeterminate = this.state.selectAll === 2;
                    }
                  }}
                  onChange={() => this.toggleSelectAll()}
                />
              );
            },
            sortable: false,
            width: 45
          }, {
            Header: couterpart.translate('work_order_worker'),
            accessor: 'workerFullName',
            filterable: false,
            width: 80,
            Cell:  ({ original }) => {
              return this.getAssignedWorkers(original)
            }
          }, {
            Header: couterpart.translate('lbl_assign_info'),
            accessor: 'ckExportFile',
            width: 100,
            sortable: false,
            Cell: props => WorkOrderUtil.getAssignInfo(props.value)
          }, {
            Header: couterpart.translate('work_order_no'),
            accessor: 'workOrderNo',
            width: 150,
            Cell: row => (
              this.linkToDetails(row)
            )
          }, {
            Header: couterpart.translate('work_order_code'),
            accessor: 'sku',
            filterable: false,
            // width: 300,
            filterMethod: (filter, row) =>
              row[filter.id].includes(filter.value)
          }, {
            Header: couterpart.translate('shop_pcode'),
            accessor: 'fullPCode',
            filterable: false,
            width: 80
          }, {
            Header: couterpart.translate('work_order_urgent_level'),
            accessor: 'isUrgentByCustomer',
            width: 50,
            Cell: row => {
              row.styles['color'] = row.value === 1 ? 'red' : 'black';
              return row.value === 1 ? 'X' : '';
            },
            filterable: false,
            filterMethod: (filter, row) =>
              row[filter.id].includes(filter.value)
          }, {
            Header: couterpart.translate('work_order_status'),
            accessor: 'status',
            width: 100,
            Cell: props => WorkOrderUtil.getStatusDescription(data, props.value)
          }, {
            Header: couterpart.translate('work_order_status_len'),
            accessor: 'lenStatus',
            width: 150,
            Cell: ({ original }) => WorkOrderUtil.getLenStatusDescription2(original)
          },{          
            Header: couterpart.translate('work_order_status_da'),
            accessor: 'daStatus',
            width: 150,
            Cell: ({ original }) => WorkOrderUtil.getDaStatusDescription2(original)       
          },{          
            Header: couterpart.translate('work_order_itype'),
            accessor: 'itemType',
            width: 150,
            Cell: props => WorkOrderUtil.getItemTypeDescription(props.value)                                                                          
          },{ 
            Header: couterpart.translate('work_order_error_code'),
            accessor: 'errorCode',
            width: 100,
            Cell: props => this.getErrorDescription(props.value)
          },{ 
            Header: 'MT',
            accessor: 'fimg',
            width: 150,
            sortable: false,
            Cell: row => (
              this.fImageRender(row)
            )
          }, {
            Header: 'MS',
            accessor: 'bimg',
            width: 150,
            sortable: false,
            Cell: row => (
              this.bImageRender(row)
            )
          }, {
            Header: couterpart.translate('item_mota'),
            accessor: 'personalization',
            filterable: false,
            sortable: false,
            width: 200
          }, {
            Header: couterpart.translate('work_order_size'),
            accessor: 'lengthSize',
            filterable: false,
            sortable: false,
            width: 50
          }, {
            Header: couterpart.translate('wo_semi'),
            accessor: 'semi',
            filterable: false,
            width: 50
          }, {
            Header: couterpart.translate('work_order_prod_deadline'),
            accessor: 'prodDeadlineTs',
            filterable: false,
            sortable: true,
            width: 120
          }, {
            Header: couterpart.translate('item_assigned_to'),
            accessor: 'designer',
            filterable: false,
            sortable: true,
            width: 100
          }, {
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            sortable: false,
            width: 250
          }, {
            Header: couterpart.translate('lbl_print_tail'),
            accessor: 'printCount',
            width: 70
          }, {
            Header: couterpart.translate('reprint_tail'),
            accessor: 'reprintTail',
            width: 70
          }, {
            Header: couterpart.translate('chot_count'),
            accessor: 'workCardId',
            width: 70
          }, {
            Header: couterpart.translate('chot_at'),
            accessor: 'chotAt',
            width: 70
          }, {
            Header: couterpart.translate('work_order_action'),
            accessor: 'action',
            width: 90,
            Cell: row => (
              <div style={{ textAlign: "center" }}>
                {this.renderEditButton(row)}
              </div>
            )
          }],
        columns4U: [
          {
            id: "idx",
            accessor: "",
            width: 40,
            Cell: row => (
              <div style={{ padding: "10px" }}>{row.index + 1}</div>
            )
          },
          {
            id: "checkbox",
            accessor: "",
            Cell: ({ original }) => {
              return (
                <div style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={this.state.selected4U[original.id] && this.state.selected4U[original.id].checked === true}
                    onChange={() => this.toggleRow4U(original)}
                  /></div>
              );
            },
            Header: x => {
              return (
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selectAll4U === 1}
                  ref={input => {
                    if (input) {
                      input.indeterminate = this.state.selectAll4U === 2;
                    }
                  }}
                  onChange={() => this.toggleSelectAll4U()}
                />
              );
            },
            sortable: false,
            width: 45
          }, {
            Header: couterpart.translate('work_order_worker'),
            accessor: 'planWorkerFullName',
            filterable: false,
            width: 100
          }, {
            Header: couterpart.translate('lbl_assign_info'),
            accessor: 'ckExportFile',
            width: 150,
            sortable: false,
            Cell: props => WorkOrderUtil.getAssignInfo(props.value)
          }, {
            Header: couterpart.translate('work_order_no'),
            accessor: 'workOrderNo',
            width: 150,
            Cell: row => (
              this.linkToDetails(row)
            )
          }, {
            Header: couterpart.translate('work_order_code'),
            accessor: 'sku',
            filterable: false,
            // width: 300,
            filterMethod: (filter, row) =>
              row[filter.id].includes(filter.value)
          }, {
            Header: couterpart.translate('shop_pcode'),
            accessor: 'fullPCode',
            filterable: false,
            width: 150
          }, {
            Header: couterpart.translate('work_order_urgent_level'),
            accessor: 'isUrgentByCustomer',
            width: 50,
            Cell: row => {
              row.styles['color'] = row.value === 1 ? 'red' : 'black';
              return row.value === 1 ? 'X' : '';
            },
            filterable: false,
            filterMethod: (filter, row) =>
              row[filter.id].includes(filter.value)
          }, {
            Header: couterpart.translate('work_order_status'),
            accessor: 'status',
            width: 100,
            Cell: props => WorkOrderUtil.getStatusDescription(data, props.value)
          }, {
            Header: couterpart.translate('work_order_next_status'),
            accessor: 'planStatus',
            width: 100,
            Cell: props => WorkOrderUtil.getStatusDescription(data, props.value)
          }, {
            Header: 'MT',
            accessor: 'fimg',
            width: 150,
            sortable: false,
            Cell: row => (
              this.fImageRender(row)
            )
          }, {
            Header: 'MS',
            accessor: 'bimg',
            width: 150,
            sortable: false,
            Cell: row => (
              this.bImageRender(row)
            )
          }, {
            Header: couterpart.translate('item_mota'),
            accessor: 'personalization',
            filterable: false,
            sortable: false,
            width: 200
          }, {
            Header: couterpart.translate('work_order_size'),
            accessor: 'lengthSize',
            filterable: false,
            sortable: false,
            width: 50
          }, {
            Header: couterpart.translate('wo_semi'),
            accessor: 'semi',
            filterable: false,
            width: 50
          }, {
            Header: couterpart.translate('work_order_prod_deadline'),
            accessor: 'prodDeadlineTs',
            filterable: false,
            sortable: true,
            width: 120
          }, {
            Header: couterpart.translate('item_assigned_to'),
            accessor: 'designer',
            filterable: false,
            sortable: true,
            width: 100
          }, {
            Header: couterpart.translate('work_order_ckExportFile'),
            accessor: 'ckExportFile',
            sortable: false,
            width: 250
          }, {
            Header: couterpart.translate('lbl_print_tail'),
            accessor: 'printCount',
            width: 70
          }, {
            Header: couterpart.translate('work_order_action'),
            accessor: 'action',
            width: 90,
            Cell: row => (
              <div style={{ textAlign: "center" }}>
                {this.renderEditButton(row)}
              </div>
            )
          }]
      })
    });

    this.loadWorker();
    this.loadItems();
    this.loadPlan();
  }

  renderAssignedWorkerRow(assignedWorker) {
      return (
          <div classname="row">
              { assignedWorker.username + "(" + assignedWorker.department + ")" }
          </div>
      );
  }

  getAssignedWorkers(row){
      if (row.assignedWorkers == null || row.assignedWorkers.length < 1){
          return "";
      }
      try {
          return(
          <>
              <div classname='col-12'>
                  {row.assignedWorkers.map(assignedWorker => this.renderAssignedWorkerRow(assignedWorker))}
              </div>
          </>
          );
      } catch (e) {

      }
      return "";
  } 

  loadPlan() {
    WorkOrderDataService.fetchNextWorkerPlans().then(data => {
      console.log('Worker Plans', data)
      this.setState({
        workerPlans: data
      });
    });

    WorkOrderDataService.fetchWorkerPlans().then(data => {
      console.log('Current Worker Plans', data)
      this.setState({
        currentWorkerPlans: data
      });
    });
  }

  getErrorDescription(errorCode) {
    return DataUtil.getErrorDescription(errorCode);   
  }

  copyPlans(jsonData) {
    return JSON.parse(JSON.stringify(jsonData));
  }

  computePlans() {

    let assignedPlans = this.copyPlans(this.state.currentWorkerPlans);

    let plans = {};
    for (let i = 0; i < assignedPlans.length; i++) {
      plans[assignedPlans[i].workerName] = assignedPlans[i];
    }

    for (let i = 0; i < this.state.workerPlans.length; i++) {
      let wp = this.copyPlans(this.state.workerPlans[i]);
      if (plans[wp.workerName] !== undefined) {
        plans[wp.workerName].exportCkCount += wp.exportCkCount;
        plans[wp.workerName].readyCount += wp.readyCount;
        plans[wp.workerName].assignedCount += wp.assignedCount;
        plans[wp.workerName].ckCount += wp.ckCount;
        plans[wp.workerName].nhamCount += wp.nhamCount;
        plans[wp.workerName].bongCount += wp.bongCount;
        plans[wp.workerName].kimCount += wp.kimCount;
        plans[wp.workerName].kiemtraCount += wp.kiemtraCount;
        plans[wp.workerName].loichosuaCount += wp.loichosuaCount;
        plans[wp.workerName].admindaduyetCount += wp.admindaduyetCount;

        plans[wp.workerName].exportCkCountP = wp.exportCkCount;
        plans[wp.workerName].readyCountP = wp.readyCount;
        plans[wp.workerName].assignedCountP = wp.assignedCount;
        plans[wp.workerName].ckCountP = wp.ckCount;
        plans[wp.workerName].nhamCountP = wp.nhamCount;
        plans[wp.workerName].bongCountP = wp.bongCount;
        plans[wp.workerName].kimCountP = wp.kimCount;
        plans[wp.workerName].kiemtraCountP = wp.kiemtraCount;
        plans[wp.workerName].loichosuaCountP = wp.loichosuaCount;
        plans[wp.workerName].admindaduyetCountP = wp.admindaduyetCount;
      } else {
        plans[wp.workerName] = wp;
        plans[wp.workerName].exportCkCountP = wp.exportCkCount;
        plans[wp.workerName].readyCountP = wp.readyCount;
        plans[wp.workerName].assignedCountP = wp.assignedCount;
        plans[wp.workerName].ckCountP = wp.ckCount;
        plans[wp.workerName].nhamCountP = wp.nhamCount;
        plans[wp.workerName].bongCountP = wp.bongCount;
        plans[wp.workerName].kimCountP = wp.kimCount;
        plans[wp.workerName].kiemtraCountP = wp.kiemtraCount;
        plans[wp.workerName].loichosuaCountP = wp.loichosuaCount;
        plans[wp.workerName].admindaduyetCountP = wp.admindaduyetCount;
      }
    }

    return plans;
  }

  renderEditButton(row) {
    if (row.original.status === 38) { //Da cat khac
      return (<></>);
    }

    if (AuthenticationService.isKhac()) {
      return (<div>
        <button className="myButton" onClick={() => this.changeCK(row)}>
          <MdDeleteForever color={ICON_COLOR} />
          &nbsp;{couterpart.translate('button_ck')}</button>
      </div>
      );
    } else {
      return (<></>);
    }
  }

  fImageRender(row) {
    if (row.original.fimg === undefined || row.original.fimg === null) {
      return (<></>)
    }
    return (
      <img className="imageBox linkTo" alt="" width={100} height={70} src={`data:image/jpeg;base64,${row.original.fimg}`} name={'F' + row.original.workOrderNo} />
    )
  }

  bImageRender(row) {
    if (row.original.bimg === undefined || row.original.bimg === null) {
      return (<></>)
    }
    return (
      <img className="imageBox linkTo" alt="" width={100} height={70} src={`data:image/jpeg;base64,${row.original.bimg}`} name={'B' + row.original.workOrderNo} />
    )
  }

  toggleRow(row) {
    let newSelected = Object.assign({}, this.state.selected);
    if (newSelected[row.id] === undefined) {
      newSelected[row.id] = { checked: true, status: row.status, shipCode: row.shipCode, ckExportFile: row.ckExportFile, workOrderNo: row.workOrderNo };
    }

    if (this.state.selected[row.id]) {
      newSelected[row.id].checked = !this.state.selected[row.id].checked;
      newSelected[row.id].status = this.state.selected[row.id].status;
      newSelected[row.id].shipCode = this.state.selected[row.id].shipCode;
      newSelected[row.id].ckExportFile = this.state.selected[row.id].ckExportFile;
      newSelected[row.id].workOrderNo = this.state.selected[row.id].workOrderNo;
    }

    this.setState({
      selected: newSelected,
      selectAll: 2
    }, () => {
      WorkOrderUtil.saveItem('supervext.selected', JSON.stringify(this.state.selected));
    });
  }

  toggleSelectAll() {
    const newSelected = Object.assign({}, this.state.selected);
    if (this.state.selectAll === 0 || this.state.selectAll === undefined) {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: true, status: x.status, shipCode: x.shipCode, ckExportFile: x.ckExportFile, workOrderNo: x.workOrderNo };
        } else {
          newSelected[x.id].checked = true;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
          newSelected[x.id].ckExportFile = x.ckExportFile;
          newSelected[x.id].workOrderNo = x.workOrderNo;
        }
      });
    } else {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: false, status: x.status, shipCode: x.shipCode };
        } else {
          newSelected[x.id].checked = false;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
          newSelected[x.id].ckExportFile = x.ckExportFile;
          newSelected[x.id].workOrderNo = x.workOrderNo;
        }
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    }, () => {
      WorkOrderUtil.saveItem('supervext.selected', JSON.stringify(this.state.selected));
    });
  }

  toggleRow4U(row) {
    let newSelected = Object.assign({}, this.state.selected4U);
    if (newSelected[row.id] === undefined) {
      newSelected[row.id] = { checked: true, status: row.status, shipCode: row.shipCode, ckExportFile: row.ckExportFile, workOrderNo: row.workOrderNo };
    }

    if (this.state.selected4U[row.id]) {
      newSelected[row.id].checked = !this.state.selected4U[row.id].checked;
      newSelected[row.id].status = this.state.selected4U[row.id].status;
      newSelected[row.id].shipCode = this.state.selected4U[row.id].shipCode;
      newSelected[row.id].ckExportFile = this.state.selected4U[row.id].ckExportFile;
      newSelected[row.id].workOrderNo = this.state.selected4U[row.id].workOrderNo;
    }

    this.setState({
      selected4U: newSelected,
      selectAll4U: 2
    });
  }

  toggleSelectAll4U() {
    const newSelected = Object.assign({}, this.state.selected4U);
    if (this.state.selectAll4U === 0 || this.state.selectAll4U === undefined) {
      this.state.workOrders4U.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: true, status: x.status, shipCode: x.shipCode, ckExportFile: x.ckExportFile, workOrderNo: x.workOrderNo };
        } else {
          newSelected[x.id].checked = true;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
          newSelected[x.id].ckExportFile = x.ckExportFile;
          newSelected[x.id].workOrderNo = x.workOrderNo;
        }
      });
    } else {
      this.state.workOrders4U.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: false, status: x.status, shipCode: x.shipCode };
        } else {
          newSelected[x.id].checked = false;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
          newSelected[x.id].ckExportFile = x.ckExportFile;
          newSelected[x.id].workOrderNo = x.workOrderNo;
        }
      });
    }

    this.setState({
      selected4U: newSelected,
      selectAll4U: this.state.selectAll4U === 0 ? 1 : 0
    });
  }

  clearSearchInfo() {
    WorkOrderUtil.removeItem("supervext.fromDate")
    WorkOrderUtil.removeItem("supervext.toDate")
    WorkOrderUtil.removeItem("supervext.orderNo")
    WorkOrderUtil.removeItem("supervext.woStatus")
    WorkOrderUtil.removeItem("supervext.workerName")
    WorkOrderUtil.removeItem("supervext.selectedWoStatusList");
    WorkOrderUtil.removeItem("supervext.semi");
    WorkOrderUtil.removeItem("supervext.byDeadline");
    WorkOrderUtil.removeItem("supervext.fromDeadlineDate");
    WorkOrderUtil.removeItem("supervext.toDeadlineDate");
    WorkOrderUtil.removeItem("supervext.deadline");
    WorkOrderUtil.removeItem("supervext.selected");
    WorkOrderUtil.removeItem("supervext.pcode");
    WorkOrderUtil.removeItem("supervext.personalization");
    WorkOrderUtil.removeItem("supervext.sortBy");
    WorkOrderUtil.removeItem("supervext.sortType");
    WorkOrderUtil.removeItem("supervext.reprintTail");
    WorkOrderUtil.removeItem("supervext.sku");
    WorkOrderUtil.removeItem("supervext.size");
    WorkOrderUtil.removeItem("supervext.notPrintTail");
    WorkOrderUtil.removeItem("supervext.notAssigned");
    WorkOrderUtil.removeItem("supervext.notPrint");
    WorkOrderUtil.removeItem("supervext.incident");
    WorkOrderUtil.removeItem("supervext.woSubStatus");
    WorkOrderUtil.removeItem("supervext.errorFilter");
    WorkOrderUtil.removeItem("supervext.includeMau");
  }
  saveSearchInfo(fromDate, toDate, orderNo, selectedWoStatusList, workerName, semi, byDeadline, fromDeadlineDate,
    toDeadlineDate, deadline, pcode, personalization, sortBy, sortType, reprintTail, sku, size, notPrintTail, notPrint, notAssigned, incident, woSubStatus, errorFilter, includeMau) {
    WorkOrderUtil.saveItem("supervext.fromDate", fromDate);
    WorkOrderUtil.saveItem("supervext.toDate", toDate);
    WorkOrderUtil.saveItem("supervext.orderNo", orderNo);
    WorkOrderUtil.saveItem("supervext.workerName", workerName);
    WorkOrderUtil.saveItem("supervext.selectedWoStatusList", JSON.stringify(selectedWoStatusList));
    WorkOrderUtil.saveItem("supervext.semi", semi);
    WorkOrderUtil.saveItem("supervext.byDeadline", byDeadline);
    WorkOrderUtil.saveItem("supervext.fromDeadlineDate", fromDeadlineDate);
    WorkOrderUtil.saveItem("supervext.toDeadlineDate", toDeadlineDate);
    WorkOrderUtil.saveItem("supervext.deadline", deadline);
    WorkOrderUtil.saveItem("supervext.pcode", pcode);
    WorkOrderUtil.saveItem("supervext.personalization", personalization);
    WorkOrderUtil.saveItem("supervext.sortBy", sortBy);
    WorkOrderUtil.saveItem("supervext.sortType", sortType);
    WorkOrderUtil.saveItem("supervext.reprintTail", reprintTail);
    WorkOrderUtil.saveItem("supervext.sku", sku);
    WorkOrderUtil.saveItem("supervext.size", size);
    WorkOrderUtil.saveItem("supervext.notPrintTail", notPrintTail);
    WorkOrderUtil.saveItem("supervext.notAssigned", notAssigned);
    WorkOrderUtil.saveItem("supervext.notPrint", notPrint);
    WorkOrderUtil.saveItem("supervext.incident", incident);

    WorkOrderUtil.saveItem("supervext.woSubStatus", woSubStatus);
    WorkOrderUtil.saveItem("supervext.errorFilter", errorFilter);
    WorkOrderUtil.saveItem("supervext.includeMau", includeMau);
  }

  onFilter() {
    this.clearSearchInfo();
    this.setState({ page: 0, selected: {} },
      () => {
        this.filterOrdersBy();
      });
  }

  onTestMsg() {
    WorkOrderDataService.testMsg();
  }

  onFilter4U() {
    this.setState({ page4U: 0, selected4U: {} }, () => {
      this.filterUnassignedOrdersBy();
    });
  }

  filterOrdersBy() {
    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0 || this.state.didMounted === false)) {
      return;
    }

    this.setState({ loading: true });
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;
    let workerName = this.state.workerName;

    let byDeadline = this.state.byDeadline;
    let fromDeadlineDate = this.state.fromDeadlineDate;
    let toDeadlineDate = this.state.toDeadlineDate;

    let assignCount = this.state.assignCount ? this.state.assignCount : 0;

    let assignDate = this.state.assignDate ? this.state.assignDate : undefined;

    let orderNo = this.state.orderNo;
    let selectedWoStatusList = this.state.selectedWoStatusList;

    let selectedWoStatusCodes = [];
    if (selectedWoStatusList) {
      for (let i = 0; i < selectedWoStatusList.length; i++) {
        selectedWoStatusCodes.push(selectedWoStatusList[i].id);
      }
    }
    if (selectedWoStatusCodes.length < 1) {
      selectedWoStatusCodes = [WO_EXPORTED_CK, WO_READY, WO_ASSIGNED_WORKER, WO_COMPLETED_CK, WO_NHAM, WO_BONG, WO_QUAYKIM, WO_XI, WO_VOBAO, WO_TOBE_FIXED, WO_KIEMTRA, WO_CANCELLED, WO_SHIP_FROMVN];
    }


    let reprintTail = this.state.reprintTail === '1' ? 1 : 0;
    let semi = this.state.semi ? this.state.semi : -1;
    let ignoreSemi = this.state.ignoreSemi;

    let page = this.state.selectedPage;
    let pageSize = this.state.pageSize;
    let selected = this.state.selected;

    let deadline = this.state.deadline;

    let pcode = this.state.pcode;
    let personalization = this.state.personalization;
    let sortBy = this.state.sortBy;
    let sortType = this.state.sortType
    let sku = this.state.sku;
    let size = this.state.size;
    let notPrintTail = this.state.notPrintTail;
    let notPrint = this.state.notPrint;
    let notAssigned = this.state.notAssigned;
    let incident = this.state.incident;
    let woSubStatus = this.state.woSubStatus;
    let includeMau = this.state.includeMau;

    let errorFilter = 0;
    try {
      errorFilter = parseInt(WorkOrderUtil.getItem('supervext.errorFilter'));
      if (isNaN(errorFilter)) {
        errorFilter = 0;
      }
    } catch (eps) {
      errorFilter = 0;
    }

    console.log("woSubStatus: " , woSubStatus);
    let errorCodes = [];
    if (this.state.woSubStatus === WO_TOBE_FIXE_LOI_CATKHAC){
      errorCodes = LOI_CAT_KHAC_LIST;
    } else if (this.state.woSubStatus === WO_TOBE_FIXE_LOIXI){
      errorCodes = LOI_XI_LIST;
    } else if (this.state.woSubStatus === WO_TOBE_FIXE_LOITHO){
      errorCodes = LOI_THO_LIST;
    }

    let selectedWoErrorCodes = []; 
    if (errorCodes.length > 0){
      for(let i = 0; i<errorCodes.length; i++){
        selectedWoErrorCodes.push(errorCodes[i]);
      }
    }

    let info = {
      fromDate: fromDate,
      toDate: toDate,
      orderNo: orderNo,
      isFull: 0,
      workerName: workerName,
      assignCount: assignCount,
      woStatusList: selectedWoStatusCodes,
      woErrorList: selectedWoErrorCodes,
      semi: semi,
      ignoreSemi: ignoreSemi,
      page: page === undefined ? 0 : page,
      pageSize: pageSize === undefined ? 20 : pageSize,
      dataType: DATA_TYPE_SUPERVISOR,
      assignDate: assignDate,
      notPrint: notPrint,
      notPrintTail: notPrintTail,
      notAssigned: notAssigned,
      byDeadline: byDeadline,
      fromDeadlineDate: fromDeadlineDate,
      toDeadlineDate: toDeadlineDate,
      deadline: deadline,
      pcode: pcode,
      personalization: personalization,
      sortBy: sortBy,
      sortType: sortType,
      sku: sku,
      size: size,
      incident: incident,
      includeMau: includeMau,
      itemType: ITEM_TYPE_LENDA
    };

    WorkOrderDataService.fetchWorkOrders(info)
      .then(data => {
        if (data.message === undefined && data.data !== undefined && data.data instanceof Array) {
          this.setState({ workOrders: data.data, spinnerVisible: false, loading: false, pages: data.pages, page: page, pageSize: pageSize, selected: selected },
            () => {
              this.saveSearchInfo(fromDate, toDate, orderNo, selectedWoStatusList, workerName, semi, byDeadline, fromDeadlineDate, toDeadlineDate,
                deadline, pcode, personalization, sortBy, sortType, reprintTail, sku, size, notPrintTail, notPrint, notAssigned, incident, woSubStatus, errorFilter, includeMau);
            });
        } else {
          this.setState({ workOrders: [], loading: false, pages: 0, page: 0, pageSize: pageSize, selected: selected });
          ToastsStore.error(data.message);
        }
      });
  }

  filterUnassignedOrdersBy() {
    if ((this.state.selectedPage4U < 0) || (this.state.pageSize4U < 0 || this.state.didMounted4U === false)) {
      return;
    }

    this.setState({ loading4U: true });
    let fromDate = this.state.fromDate4U;
    let toDate = this.state.toDate4U;

    let byDeadline = this.state.byDeadline4U;
    let fromDeadlineDate = this.state.fromDeadlineDate4U;
    let toDeadlineDate = this.state.toDeadlineDate4U;
    let orderNo = this.state.orderNo4U;
    let selectedWoStatusList = this.state.selectedWoStatusList4U;

    let selectedWoStatusCodes = [];
    if (selectedWoStatusList) {
      for (let i = 0; i < selectedWoStatusList.length; i++) {
        selectedWoStatusCodes.push(selectedWoStatusList[i].id);
      }
    }
    if (selectedWoStatusCodes.length < 1) {
      selectedWoStatusCodes = [WO_EXPORTED_CK];
    }

    let semi = this.state.semi4U ? this.state.semi4U : -1;
    let ignoreSemi = this.state.ignoreSemi4U;

    let page = this.state.selectedPage4U;
    let pageSize = this.state.pageSize4U;
    let selected = this.state.selected4U;

    let deadline = this.state.deadline4U;

    let pcode = this.state.pcode4U;
    let personalization = this.state.personalization4U;
    let sortBy = this.state.sortBy4U;
    let sortType = this.state.sortType4U
    let notPrint = this.state.notPrint;
    let notAssigned = this.state.notAssigned;

    let info = {
      fromDate: fromDate,
      toDate: toDate,
      orderNo: orderNo,
      isFull: 0,
      woStatusList: selectedWoStatusCodes,
      semi: semi,
      ignoreSemi: ignoreSemi,
      page: page === undefined ? 0 : page,
      pageSize: pageSize === undefined ? 20 : pageSize,
      dataType: DATA_TYPE_SUPERVISOR,
      notPrint: notPrint,
      notAssigned: notAssigned,
      byDeadline: byDeadline,
      fromDeadlineDate: fromDeadlineDate,
      toDeadlineDate: toDeadlineDate,
      deadline: deadline,
      pcode: pcode,
      personalization: personalization,
      sortBy: sortBy,
      sortType: sortType
    };

    WorkOrderDataService.fetchUnassignedWorkOrders(info)
      .then(data => {
        if (data.message === undefined && data.data !== undefined && data.data instanceof Array) {
          this.setState({ workOrders4U: data.data, spinnerVisible: false, loading4U: false, pages4U: data.pages, page4U: page, pageSize4U: pageSize, selected4U: selected });
        } else {
          this.setState({ workOrders4U: [], loading4U: false, pages4U: 0, page4U: 0, pageSize4U: pageSize, selected4U: selected });
          ToastsStore.error(data.message);
        }
      });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  markForWorker() {
    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_change_wo_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            this.setState({ spinnerVisible: true }, () => {
              let selectedItems = [];
              if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
                for (let key in this.state.selected) {
                  if (this.state.selected[key].checked === true) {
                    selectedItems.push(parseInt(key));
                  }
                }
              }
              // console.log("[selectedItems]: ", selectedItems);
              WorkOrderDataService.markForWorker(selectedItems).then(data => {
                this.setState({ childRefreshCount: this.state.childRefreshCount + 1 }, () => {
                  this.filterOrdersBy();
                  this.sleep(1000).then(() => { this.setState({ spinnerVisible: false }); });
                })

              });
            });
          } catch (e) {
            this.sleep(1000).then(() => { this.setState({ spinnerVisible: false }); });
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  handleFromDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDate: sDate
    });
  }

  handleToDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDate: sDate
    });
  }

  handleFromDateChange4U(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDate4U: sDate
    });
  }

  handleToDateChange4U(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDate4U: sDate
    });
  }

  handleAssignDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      assignDate: sDate
    });
  }

  handleStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      status: value
    });
  }

  handleWoChangeStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      woChangedStatus: value
    });
  }

  handleCountryChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    WorkOrderUtil.saveItem("supervext.country", value)
    this.setState({
      country: value
    });
  }

  handleCustomerChange(e) {
    let value = e.target.value;
    this.setState({
      customer: value
    });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.onFilter()
    }
  }

  handleOrderNoChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      orderNo: value
    });
  }

  handlePcodeChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      pcode: value
    });
  }

  handlePersonalizationChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      personalization: value
    });
  }

  handleIncludeMauClick() {
    if (this.state.includeMau === 1) {
      this.setState({ includeMau: 0 }, () => {

      });
    } else {
      this.setState({ includeMau: 1 }, () => {

      });
    }
  }

  handleOrderNoChange4U(e) {
    let value = e.target.value;
    this.setState({
      orderNo4U: value
    });
  }

  handlePcodeChange4U(e) {
    let value = e.target.value;
    this.setState({
      pcode4U: value
    });
  }

  handlePersonalizationChange4U(e) {
    let value = e.target.value;
    this.setState({
      personalization4U: value
    });
  }

  handleWorkerNameChange(e) {
    let value = e.target.value;
    this.setState({
      workerName: value
    });
  }

  handleAssignCountChange(e) {
    let value = e.target.value;
    this.setState({
      assignCount: value
    });
  }

  renderWoChangeStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <select onChange={this.handleWoChangeStatusChange.bind(this)} className="selectBox2"
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  exportWorkOrders(infos) {
    this.setState({
      selectedWorkOrders: infos
    });
  }

  handleSelectChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      selectedWorker: value
    });
  };

  handleSelectChange4U(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      selectedWorker4U: value
    });
  };

  handleWorkerFilterChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      workerName: value
    });
  };

  handleSelectSemiChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      semiRequired: value
    });
  }

  renderWorkerOption(option) {
    return (
      <option key={option.key} value={option.key}>{option.userName}</option>
    );
  }

  handleAssignWorkerOnlyClick() {
    if (this.state.assignOnly === '1') {
      this.setState({ assignOnly: '0' });
    } else {
      this.setState({ assignOnly: '1' });
    }
  }

  handleSemiClick() {
    if (this.state.semi === '1') {
      this.setState({ semi: '0', ignoreSemi: '-1' });
    } else {
      this.setState({ semi: '1', ignoreSemi: '-1' });
    }
  }
  handleSemiClick4U() {
    if (this.state.semi4U === '1') {
      this.setState({ semi4U: '0', ignoreSemi4U: '-1' });
    } else {
      this.setState({ semi4U: '1', ignoreSemi4U: '-1' });
    }
  }

  handleNotPrintClick() {
    if (this.state.notPrint === '1') {
      this.setState({ notPrint: '0' });
    } else {
      this.setState({ notPrint: '1' });
    }
  }

  handleNotPrintTailClick() {
    if (this.state.notPrintTail === '1') {
      this.setState({ notPrintTail: '0' });
    } else {
      this.setState({ notPrintTail: '1' });
    }
  }

  handleNotAssignedClick() {
    if (this.state.notAssigned === '1') {
      this.setState({ notAssigned: '0' });
    } else {
      if (this.state.notAssigned === '0') {
        this.setState({ notAssigned: '1' });
      } else {
        this.setState({ notAssigned: '-1' });
      }
    }
  }

  handleIgnoreSemiClick() {
    if (this.state.ignoreSemi === '1') {
      this.setState({ semi: '0', ignoreSemi: '0' });
    } else {
      this.setState({ semi: '-1', ignoreSemi: '1' });
    }
  }

  handleIgnoreSemiClick4U() {
    if (this.state.ignoreSemi4U === '1') {
      this.setState({ semi4U: '0', ignoreSemi4U: '0' });
    } else {
      this.setState({ semi4U: '-1', ignoreSemi4U: '1' });
    }
  }

  renderFilterWorkerOption(option) {
    return (
      <option key={option.key} value={option.userName}>{option.userName}</option>
    );
  }

  renderFilterWorkers() {
    if ((this.state.worker === undefined)) {
      return (<></>);
    }
    return (
      <>
        <select onChange={this.handleWorkerFilterChange.bind(this)} className="select_margin" style={{ width: "100%", height: "50%" }}>
          <option key="" value=""></option>
          {this.state.worker !== undefined && this.state.worker.map(option => this.renderFilterWorkerOption(option))}
        </select>&nbsp;&nbsp;
      </>
    );
  }

  renderWorkers() {
    if ((this.state.worker === undefined)) {
      return (<></>);
    }
    return (
      <>
        <Multiselect
            options={this.state.worker}
            selectedValues={this.state.selectedWorkersToAssign}
            onSelect={this.onSelectWorker.bind(this)}
            onRemove={this.onRemoveWorker.bind(this)}
            displayValue="userName"
            showCheckbox={true}
          />
      </>
    );
  }

  renderPlanWorkers() {
    if ((this.state.worker === undefined)) {
      return (<></>);
    }
    return (
      <>
        <select onChange={this.handleSelectChange4U.bind(this)} className="select_margin">
          <option key="" value=""></option>
          {this.state.worker !== undefined && this.state.worker.map(option => this.renderWorkerOption(option))}
        </select>&nbsp;&nbsp;
      </>
    );
  }

  renderSemi() {
    return (
      <>
        <select onChange={this.handleSelectSemiChange.bind(this)} className="select_margin">
          <option key="semi_no" value="0">Không Semi</option>
          <option key="semi_yes" value="1">Semi</option>
        </select>&nbsp;&nbsp;
      </>
    );
  }

  handleSetStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({
      newStatus: value
    }));
  }

  handleWorkOrderNoteChange(e) {
    let newValue = e.target.value;
    this.setState(prevState => ({
      workOrderNote: newValue
    }));
  }

  isReadyableWo(selectedItems) {
    let count = 0;
    let total = 0;
    for (let key in this.state.selected) {
      if (this.state.selected[key].checked === true) {
        total++;
        if (this.state.selected[key].status !== WO_ASSIGNED_WORKER) {
          alert('Tình trạng Đơn hàng (' + this.state.selected[key].workOrderNo + ' - ' + this.state.selected[key].status + ') không phải \'assign thợ\'');
          return false;
        } else if (this.state.selected[key].ckExportFile === null || this.state.selected[key].ckExportFile === undefined) {
          alert('Đơn hàng (' + this.state.selected[key].workOrderNo + ') chưa có ckExportFile');
          return false;
        } else {
          count++;
        }
      }
    }

    if (count === total) {
      return true;
    }
    alert('Có đơn hàng được chọn chưa sẵn sàng cho cắt khắc');
    return false;
  }

  isAssignableWo(selectedItems) {
    let count = 0;
    let total = 0;
    for (let key in this.state.selected) {
      if (this.state.selected[key].checked === true) {
        total++;
        if (this.state.selected[key].status !== WO_EXPORTED_CK) {
          return false;
        } else {
          count++;
        }
      }
    }

    if (count === total) {
      return true;
    }
    return false;
  }

  changeWorker(assignOnly) {
    let selectedItems = [];
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true) {
          selectedItems.push(parseInt(key));
        }
      }
    }

    if (selectedItems.length < 1) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    if (!this.isAssignableWo(selectedItems) && !assignOnly) {
      alert(couterpart.translate('error_selected_items_not_assignable'));
      return;
    }

    if (this.state.selectedWorkersToAssign === undefined || this.state.selectedWorkersToAssign === null || this.state.selectedWorkersToAssign.length < 1) {
      alert(couterpart.translate('error_selected_worker_empty'));
      return;
    }

    // alert(this.state.selectedWorker)

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_change_wk_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            // this.setState({spinnerVisible: true}, () =>{
            // console.log("[selectedItems]: ", selectedItems);
            let workerIds = [];
            for(let i = 0; i<this.state.selectedWorkersToAssign.length; i++){
              workerIds.push(this.state.selectedWorkersToAssign[i].value);
            }
            WorkOrderDataService.assignWorkers(selectedItems, workerIds, assignOnly).then(data => {
              if (!isNaN(data) && parseInt(data) >= 0){
                this.setState({ childRefreshCount: this.state.childRefreshCount + 1, selected: [] }, () => {
                    this.filterOrdersBy();
                })
              } else {
                alert(data);
              }
            });
            // });        
          } catch (e) {
            // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  chotWorker() {
    let selectedItems = [];
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true) {
          selectedItems.push(parseInt(key));
        }
      }
    }

    if (selectedItems.length < 1) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_chot_tho_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            WorkOrderDataService.chotWorker(selectedItems).then(data => {
              this.setState({ childRefreshCount: this.state.childRefreshCount + 1, selected: [] }, () => {
                this.filterOrdersBy();
              })

            });
          } catch (e) {
            // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  resolveIncidents() {
    let selectedItems = [];
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true) {
          selectedItems.push(parseInt(key));
        }
      }
    }

    if (selectedItems.length < 1) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_resolve_incident_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            WorkOrderDataService.resolveIncidents(selectedItems).then(data => {
              this.setState({ childRefreshCount: this.state.childRefreshCount + 1, selected: [] }, () => {
                this.filterOrdersBy();
              })

            });
          } catch (e) {
            // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  planWorker() {
    let selectedItems = [];
    if ((this.state.selected4U !== undefined) && (this.state.selected4U !== null)) {
      for (let key in this.state.selected4U) {
        if (this.state.selected4U[key].checked === true) {
          selectedItems.push(parseInt(key));
        }
      }
    }

    if (selectedItems.length < 1) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    if (this.state.selectedWorker4U === undefined || this.state.selectedWorker4U === null || this.state.selectedWorker4U < 1) {
      alert(couterpart.translate('error_selected_worker_empty'));
      return;
    }

    WorkOrderDataService.planWorkers(selectedItems, this.state.selectedWorker4U).then(data => {
      WorkOrderDataService.fetchNextWorkerPlans().then(data => {
        this.setState({
          workerPlans: data,
          selected4U: []
        }, () => {
          this.filterUnassignedOrdersBy();
        });
      });
    });
  }

  changeToReady() {
    let selectedItems = [];
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true) {
          selectedItems.push(parseInt(key));
        }
      }
    }

    if (selectedItems.length < 1) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    if (!this.isReadyableWo(selectedItems)) {
      alert(couterpart.translate('error_selected_items_not_readyable'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_change_to_ready_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            // this.setState({spinnerVisible: true}, () =>{
            WorkOrderDataService.changeToReady(selectedItems).then(data => {
              this.setState({ selected: {} }, () => {
                this.filterOrdersBy();
              });
            });
            // });        
          } catch (e) {
            // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  printTails() {
    try {
      let selectedItems = [];
      if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
        for (let key in this.state.selected) {
          if (this.state.selected[key].checked === true) {
            selectedItems.push(parseInt(key));
          }
        }
      }

      if (selectedItems.length < 1) {
        alert(couterpart.translate('error_selected_items_empty'));
        return;
      }

      WorkOrderDataService.getDesignerExportedInfo(selectedItems, DATA_TYPE_PRINT_TAIL).then(existedRes => {
        let oldExportedIds = [];
        let existedFiles = '';
        let sep = '';


        if (existedRes && existedRes.exportInfoList && existedRes.exportInfoList.length > 0) {
          for (let i = 0; i < existedRes.exportInfoList.length; i++) {
            oldExportedIds.push(existedRes.exportInfoList[i].id);
            existedFiles += sep + existedRes.exportInfoList[i].filename;
            sep = ',';
          }
        }
        console.log(existedFiles);

        if (oldExportedIds.length > 0) {
          let answ = window.confirm('Work orders (' + existedRes.exportedWorkOrderList.join() + ') đã in đuôi chuột (' + existedFiles + '). Bạn có muốn in lại?');
          if (!answ) {
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
            return;
          }
        }

        UserDataService.retrieveNextFilename(DATA_TYPE_PRINT_TAIL).then(res => {

          this.setState({ spinnerVisible: true }, () => {
            WorkOrderDataService.printTails(selectedItems, res.filename, res.id, oldExportedIds, DATA_TYPE_PRINT_TAIL).then(data => {
              this.filterOrdersBy();
              const downloadUrl = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', res.filename);
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
              this.setState({ selected: [] });
            });
          });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  changeSemi() {
    let selectedItems = [];
    if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
      for (let key in this.state.selected) {
        if (this.state.selected[key].checked === true) {
          selectedItems.push(parseInt(key));
        }
      }
    }

    if (selectedItems.length < 1) {
      alert(couterpart.translate('error_selected_items_empty'));
      return;
    }

    this.dialog.show({
      title: couterpart.translate("msg_title_confirm"),
      body: couterpart.translate("msg_change_semi_confirm"),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          try {
            // this.setState({spinnerVisible: true}, () =>{
            WorkOrderDataService.changeSemi(selectedItems, this.state.semiRequired ? this.state.semiRequired : 0).then(data => {
              // this.setState({ childRefreshCount: this.state.childRefreshCount + 1}, () => {
              this.filterOrdersBy();
              this.setState({ selected: [] });
              // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
              // })

            });
            // });        
          } catch (e) {
            // this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
          }
        })
      ],
      bsSize: 'small',
      onHide: (dialog) => {
        dialog.hide()
        console.log('closed by clicking background.')
      }
    });
  }

  exportExcel() {
    try {
      let selectedItems = [];
      if ((this.state.selected !== undefined) && (this.state.selected !== null)) {
        for (let key in this.state.selected) {
          if (this.state.selected[key].checked === true) {
            selectedItems.push(parseInt(key));
          }
        }
      }

      if (selectedItems.length < 1) {
        alert(couterpart.translate('error_selected_items_empty'));
        return;
      }

      WorkOrderDataService.getDesignerExportedInfo(selectedItems, DATA_TYPE_SUPERVISOR).then(existedRes => {
        console.log('getDesignerExportedInfo', existedRes);
        let oldExportedIds = [];
        let existedFiles = '';
        let sep = '';


        if (existedRes && existedRes.exportInfoList && existedRes.exportInfoList.length > 0) {
          for (let i = 0; i < existedRes.exportInfoList.length; i++) {
            oldExportedIds.push(existedRes.exportInfoList[i].id);
            existedFiles += sep + existedRes.exportInfoList[i].filename;
            sep = ',';
          }
        }
        console.log(existedFiles);

        if (oldExportedIds.length > 0) {
          let answ = window.confirm('Work orders (' + existedRes.exportedWorkOrderList.join() + ') đã exported (' + existedFiles + '). Bạn có muốn export lại?');
          if (!answ) {
            this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
            return;
          }
        }

        UserDataService.retrieveNextFilename(DATA_TYPE_SUPERVISOR).then(res => {

          this.setState({ spinnerVisible: true }, () => {
            WorkOrderDataService.exportExcelForCk(selectedItems, res.filename, res.id, oldExportedIds, DATA_TYPE_SUPERVISOR).then(data => {
              this.setState({ selected: {} }, () => {
                this.filterOrdersBy();
              });
              const downloadUrl = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', res.filename);
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
              this.setState({ selected: {} });
            });
          });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  renderReadyButton() {
    let x = this.checkSelectedStatus();
    if (x === 2) {
      return (<></>);
    }

    return (
      <button className="myButton"
        onClick={this.changeToReady.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_ready')}
      </button>
    )
  }

  checkSelectedStatus() {
    let xuatCkCount = 0;
    let assignedCount = 0;
    let otherCount = 0;
    if (this.state.selectedWoStatusList === undefined){
      return 0;
    }
    for (let i = 0; i < this.state.selectedWoStatusList.length; i++) {
      if (this.state.selectedWoStatusList[0].id === WO_EXPORTED_CK) {
        xuatCkCount++;
      } if (this.state.selectedWoStatusList[0].id === WO_ASSIGNED_WORKER) {
        assignedCount++;
      } else {
        otherCount++;
      }
    }

    if (xuatCkCount > 0 && otherCount > 0) {
      return 3; //All
    }

    if (xuatCkCount > 0 && otherCount <= 0) {
      return 1 //To be assigned
    }

    if (assignedCount > 0 && otherCount <= 0 && xuatCkCount <= 0) {
      if (this.state.semi == 0) {
        return 2; //no semi & assigned
      }
      return 4 //to be ready
    }

    if (xuatCkCount <= 0 && otherCount > 0) {
      return 2 //Can be changed
    }
    return 0
  }

  renderChangeWorkerButton() {
    let check = this.checkSelectedStatus();
    if (check === 1) { //to be assigned
      return (
        <button className="myButton"
          onClick={this.changeWorker.bind(this, 0)}>
          <MdImportExport color={ICON_COLOR} />
          &nbsp;{couterpart.translate('button_change_worker')}
        </button>
      );
    }

    if (check === 2) { //to be assigned
      return (
        <button className="myButton"
          onClick={this.changeWorker.bind(this, 1)}>
          <MdImportExport color={ICON_COLOR} />
          &nbsp;{couterpart.translate('button_change_worker_only')}
        </button>
      )
    }

    return (
      <>
        <button className="myButton"
          onClick={this.changeWorker.bind(this, 0)}>
          <MdImportExport color={ICON_COLOR} />
          &nbsp;{couterpart.translate('button_change_worker')}
        </button>
        <button className="myButton"
          onClick={this.changeWorker.bind(this, 1)}>
          <MdImportExport color={ICON_COLOR} />
          &nbsp;{couterpart.translate('button_change_worker_only')}
        </button>
      </>
    )

  }

  renderChotWorkerButton() {
    return (
      <button className="myButton"
        onClick={this.chotWorker.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_chot_worker')}
      </button>
    )
  }

  renderResolveIncidentButton() {
    return (
      <button className="myButton"
        onClick={this.resolveIncidents.bind(this)}>
        <MdImportExport color={ICON_COLOR} />
        &nbsp;{couterpart.translate('button_incident')}
      </button>
    )
  }

  handleClose() {
    this.setState({ show: false },
      () => {
        // this.sleep(500).then(() => {
        //     this.scanWorkOrderNo.focus();
        // })
      });
  }

  showWorkOrdersByNo(no) {
    WorkOrderDataService.scanByNo(no).then(data => {
      this.setState({
        workOrder: data
      }, () => {
        NoteDataService.retrieveNotesByWorkOrder(this.state.workOrder.id).then(data => {
          this.setState({
            notes: data,
            show: true
          });
        });
      });
    });
  }

  renderLenStatus(wo){
      return (<label style={{marginTop:"10px"}}>{ WorkOrderUtil.getLenStatusDescription2(wo) }</label>);
  }

  renderDaStatus(wo){
      return (<label style={{marginTop:"10px"}}>{ WorkOrderUtil.getDaStatusDescription2(wo) }</label>);
  }

  renderAssignedWorkerRow(assignedWorker) {
    if  (assignedWorker.department === null || assignedWorker.department === undefined || assignedWorker.department.length < 1){
      return (
          <div classname="row">
              { assignedWorker.username }
          </div>
      );
    }
    return (
        <div classname="row">
            { assignedWorker.username + "(" + assignedWorker.department + ")" }
        </div>
    );
  }

  getAssignedWorkers(wo){
      if (wo.itemType === undefined || wo.itemType === null || wo.itemType <= ITEM_TYPE_NONE){
          return (<> { wo.workerFullName } </>)
      }

      if (wo.assignedWorkers == null || wo.assignedWorkers.length < 1){
          return "";
      }
      try {
          return(
          <>
              <div classname='col-12'>
                  {wo.assignedWorkers.map(assignedWorker => this.renderAssignedWorkerRow(assignedWorker))}
              </div>
          </>
          );
      } catch (e) {

      }
      return "";
  }

  renderWoDetails() {
    return (
      <div className="row">
        <div className="col-8">
          <div className="row">
            <div className="col-3 border-top border-left border-light-gray">
              <div className="row">
                <div className="col-2">
                  <img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode} />
                </div>
              </div>
              <div className="row">
                <div className="col-2">
                  <label style={{ "margin-left": '2px' }}>{this.state.workOrder.workOrderNo}</label>
                </div>
              </div>
            </div>
            <div className="col-1 border-top border-left border-light-gray">
              <div className="row border-bottom border-light-gray">
                <label className="labelBox_red">{couterpart.translate('work_order_urgent_level')}</label>
              </div>
              <div className="row">
                <label style={{ color: 'red', margin: '2px' }}>{this.state.workOrder.urgent}</label>
              </div>
            </div>
            <div className="col-3 border-top border-left border-light-gray">
              <div className="row border-bottom border-light-gray">
                <div className="col">
                  <label className="labelBox">{couterpart.translate('work_order_order_date_s')}</label>
                </div>
              </div>
              <div className="row border-bottom border-light-gray">
                <div className="col">
                  <label className="labelBox">
                    {couterpart.translate('work_order_web_dealine')}
                  </label>
                </div>
              </div>
              <div className="row border-light-gray">
                <div className="col">
                  <label className="labelBox">{couterpart.translate('work_order_prod_dealine')}</label>
                </div>
              </div>
            </div>
            <div className="col-3 border-top border-left border-right border-light-gray">
              <div className="row border-bottom border-light-gray">
                <div className="col border-light-gray">
                  <label className="labelValueBox">
                    {WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}
                  </label>
                </div>
              </div>
              <div className="row border-bottom border-light-gray">
                <div className="col border-light-gray">
                  <label className="labelValueBox">
                    {WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineWeb)}
                  </label>
                </div>
              </div>
              <div className="row border-light-gray">
                <div className="col border-light-gray">
                  <label className="labelValueBox">
                    {WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs)}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-1 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_code')}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{this.state.workOrder.sku}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('shop_pcode')}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelValueBox">{this.state.workOrder.fullPCode}</label>
            </div>
            <div className="col-1 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_font')}</label>
            </div>
            <div className="col-2 border-top border-left border-right border-light-gray">
              {this.state.workOrder.font}
            </div>
          </div>
          <div className="row">
            <div className="col-1 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_color')}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              {this.state.workOrder.colorMaterial}
            </div>
            <div className="col-1 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_type')}</label>
            </div>
            <div className="col-3 border-top border-left border-light-gray">
              {this.state.workOrder.shapeDesign}
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox_red">{couterpart.translate('work_order_urgent_by_cust')}</label>
            </div>
            <div className="col-1 border-top border-left border-right border-light-gray">
              {this.state.workOrder.isUrgentByCustomer}
            </div>
          </div>
          <div className="row">
            <div className="col-1 border-top border-left border-light-gray">
              <label className="labelBox_red">{couterpart.translate('work_order_quantity_s')}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              {this.state.workOrder.qty}
            </div>
            <div className="col-1 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_size')}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              {this.state.workOrder.lengthSize}
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_shipto')}</label>
            </div>
            <div className="col-2 border-top border-left border-right border-light-gray">
              {this.state.workOrder.shipTo}
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_customer_s')}</label>
            </div>
            <div className="col-3 border-top border-left border-light-gray">
              <label className="labelValueBox">{this.state.workOrder.customer}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_urgent')}</label>
            </div>
            <div className="col-3 border-top border-left border-right border-light-gray">
              {this.state.workOrder.carrierServiceRequested}
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_design_level')}</label>
            </div>
            <div className="col-1 border-top border-left border-right border-light-gray">
              {this.state.workOrder.type}
            </div>
            <div className="col-1 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_designer')}</label>
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              {this.state.workOrder.designers}
            </div>
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
            </div>
            <div className="col-2 border-top border-left border-right border-light-gray">
              <label className="labelValueBox">{
                WorkOrderUtil.formatShortDisplayDateMMddyyyy2(this.state.workOrder.ngayNhapLieu)
              }</label>
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">
                {couterpart.translate('work_order_personalization')}
              </label>
            </div>
            <div className="col-8 border-top border-left border-right border-light-gray">
              {this.state.workOrder.personalization}
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_special_note')}</label>
            </div>
            <div className="col-8 border-top border-left border-right border-light-gray">
              {this.state.workOrder.notesInternal ? this.state.workOrder.notesInternal : ''}
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">{couterpart.translate('work_order_ycdb_shipping')}</label>
            </div>
            <div className="col-8 border-top border-left border-right border-light-gray">
              {this.state.workOrder.ycdbShipping ? this.state.workOrder.ycdbShipping : ''}
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">
                {couterpart.translate('label_note')}
              </label>
            </div>
            <div className="col-8 border-top border-left border-right border-light-gray">
              {this.state.workOrder.notesFromService ? this.state.workOrder.notesFromService : ''}
            </div>
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">
                {couterpart.translate('work_order_status')}
              </label>
            </div>
            <div className="col-3 border-top border-left border-right border-light-gray">
              { WorkOrderUtil.getStatusDescription(this.state.allStatus, this.state.workOrder.status)}
            </div>
            <div className="col-2 border-top border-left border-right border-light-gray">                            
                <label className="labelBox">{couterpart.translate('work_order_worker')}</label>
            </div>
            <div className="col-3 border-top border-left border-right border-light-gray">
                { this.getAssignedWorkers (this.state.workOrder) }
            </div>
          </div>
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{ couterpart.translate('work_order_status_len') }</label>
              </div>                            
              <div className="col-8">
                  <div className="row">
                      <div className="col-12 border-top border-left border-right border-light-gray">
                          { this.renderLenStatus(this.state.workOrder) }
                      </div>
                  </div>                              
              </div>                            
          </div>
          <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                  <label className="labelBox">{ couterpart.translate('work_order_status_da') }</label>
              </div>                            
              <div className="col-8 border-right border-light-gray">
                  <div className="row">
                      <div className="col-12 border-top border-left border-right border-light-gray">
                          { this.renderDaStatus(this.state.workOrder) }
                      </div>
                  </div>                              
              </div>                            
          </div>
          <div className="row">
            <div className="col-2 border-top border-left border-light-gray">
              <label className="labelBox">
                {couterpart.translate('incident')}
              </label>
            </div>
            <div className="col-8 border-top border-left border-right border-light-gray">
              <lable style={{ color: 'orange' }}>{this.state.workOrder.fillSKU}</lable>
            </div>
          </div>
          <div className="row">
            <div className="col-10 border-top border-left border-right border-bottom border-light-gray">
              <br />
              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>{couterpart.translate('work_order_original_info')}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <p>
                    {couterpart.translate('work_order_quantity_s')}: {this.state.workOrder.originalQty} <br />
                    {couterpart.translate('work_order_code')}: {this.state.workOrder.originalSKU} <br />
                    {couterpart.translate('work_order_urgent')}: {this.state.workOrder.originalServiceRequested}<br />
                    {couterpart.translate('work_order_options')}: {this.state.workOrder.options}<br />
                    {couterpart.translate('work_order_customer_note')}: {this.state.workOrder.notesFromBuyer}
                  </p>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>{couterpart.translate('label_note')}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <pre className="note-items">
                    {this.renderNotes()}
                  </pre>
                </ExpansionPanelDetails>
              </ExpansionPanel>
              <br />
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="row">
            <label htmlFor="">Hinh Khach: {this.state.workOrder.imageURL}</label>
          </div>
          <div className="row">
            <WorkOrderAdditions mode="MODE_EDIT"
              caption={couterpart.translate('work_order_additions')}
              workOrderId={this.state.workOrder.id}
              isUpdated={this.state.updated} />
          </div>
          <div className="row">&nbsp;</div>
          <div className="row">
            <WorkOrderImages mode="MODE_EDIT" largeMode={1}
              workOrderId={this.state.workOrder.id}
              isUpdated={this.state.updated} />
          </div>
        </div>
      </div>
    );
  }

  renderWorkOrderDialog() {
    return (
      <>
        <Modal
          show={this.state.show}
          onHide={() => this.setState({ show: false })}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              {couterpart.translate('wo_details_title')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderWoDetails()}
          </Modal.Body>
        </Modal>
      </>
    )
  }

  getOrderNote(note) {
    let idx = note.indexOf('order_note');
    if (idx >= 0) {
      let dt = "";
      if (note.length > 18) {
        dt = note.substring(0, 18) + ': ';
      }

      let orderNote = note.substring(idx);
      let idx2 = orderNote.indexOf('->');
      if (idx2 >= 0) {
        let s = orderNote.substring(idx2)
        let idx3 = s.indexOf('\n\r  ');
        if (idx3 >= 0) {
          return dt + orderNote.substring(0, idx2 + idx3)
        }
        return dt + orderNote
      }
      return dt + orderNote;
    }
    return ''
  }

  renderNotes() {
    if (this.state.notes === undefined) {
      return "";
    }

    let s = "";
    for (let i = 0; i < this.state.notes.length; i++) {
      s += this.getOrderNote(this.state.notes[i].note) + "\r\n";
    }
    return s;
  }

  handleByDeadlineClick() {
    if (this.state.byDeadline === '1') {
      this.setState({ byDeadline: '0' });
    } else {
      this.setState({ byDeadline: '1' });
    }
  }

  handleByDeadlineClick4U() {
    if (this.state.byDeadline4U === '1') {
      this.setState({ byDeadline4U: '0' });
    } else {
      this.setState({ byDeadline4U: '1' });
    }
  }

  handleFromDeadlineDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDeadlineDate: sDate
    });
  }

  handleToDeadlineDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDeadlineDate: sDate
    });
  }

  handleFromDeadlineDateChange4U(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDeadlineDate4U: sDate
    });
  }

  handleToDeadlineDateChange4U(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDeadlineDate4U: sDate
    });
  }

  handleDeadlineClick(e) {
    let value = e.target.value;
    this.setState({ deadline: value });
  }

  handleReprintTailClick(e) {
    if (this.state.reprintTail === '1') {
      this.setState({ reprintTail: '0' });
    } else {
      this.setState({ reprintTail: '1' });
    }
  }

  handleIncidentClick(e) {
    if (this.state.incident === 'Y') {
      this.setState({ incident: 'N' });
    } else {
      this.setState({ incident: 'Y' });
    }
  }

  handleDeadlineClick4U(e) {
    let value = e.target.value;
    this.setState({ deadline4U: value });
  }

  renderDealine() {
    return (
      <>
        <input type="radio" value="1" checked={this.state.deadline === '1' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline')} </label>&nbsp;&nbsp;
        <input type="radio" value="2" checked={this.state.deadline === '2' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline_no')} </label>&nbsp;&nbsp;
        <input type="radio" value="0" checked={this.state.deadline === '0' ? true : false} onChange={this.handleDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_deadline_all')} </label>
      </>
    );
  }

  renderReprintTail() {
    return (
      <>
        <input type="checkbox" value="1" checked={this.state.reprintTail === '1' ? true : false} onChange={this.handleReprintTailClick.bind(this)} /> <label> {couterpart.translate('reprint_tail')} </label>
      </>
    );
  }

  renderIncident() {
    return (
      <>
        <input type="checkbox" value="Y" checked={this.state.incident === 'Y' ? true : false} onChange={this.handleIncidentClick.bind(this)} /> <label> {couterpart.translate('incident')} </label>
      </>
    );
  }

  handleSizeChange(e) {
    let value = e.target.value;
    this.setState({
      size: value
    });
  }

  renderSize() {
    return (
      <>
        <input type="text" defaultValue={this.state.size} style={{ width: "100%" }}
          placeholder={couterpart.translate('work_order_size')}
          onChange={this.handleSizeChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleSizeChange(e) }, 0); }} />
      </>
    );
  }

  renderDealine4U() {
    return (
      <>
        <input type="radio" value="1" checked={this.state.deadline4U === '1' ? true : false} onChange={this.handleDeadlineClick4U.bind(this)} /> <label> {couterpart.translate('wo_deadline')} </label>&nbsp;&nbsp;
        <input type="radio" value="2" checked={this.state.deadline4U === '2' ? true : false} onChange={this.handleDeadlineClick4U.bind(this)} /> <label> {couterpart.translate('wo_deadline_no')} </label>&nbsp;&nbsp;
        <input type="radio" value="0" checked={this.state.deadline4U === '0' ? true : false} onChange={this.handleDeadlineClick4U.bind(this)} /> <label> {couterpart.translate('wo_deadline_all')} </label>
      </>
    );
  }

  handleClose3() {
    WorkOrderDataService.resetPlan();
    this.setState({ show3: false });
  }

  onSave() {
    WorkOrderDataService.applyPlan();
    this.setState({ show3: false });
  }

  showWorkerPlan() {
    this.filterUnassignedOrdersBy();
    this.loadPlan();
    this.setState({ show3: true });

  }

  objectToArray(plans) {
    let listItems = [];
    for (const property in plans) {
      listItems.push(plans[property]);
    }
    return listItems;
  }

  renderValue(vl) {
    if (isNaN(vl)) {
      vl = 0;
    }
    return (
      <>
        {vl <= 0 ? (
          <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
            {vl}
          </div>
        ) : (
          <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
            <b className='fmt'>{vl} </b>
          </div>
        )}
      </>
    )
  }

  renderWorkerPlans() {
    if (this.state.workerPlans === undefined || this.state.workerPlans === null || !(this.state.workerPlans instanceof Array)) {
      return (<></>);
    }

    if (this.state.currentWorkerPlans === undefined || this.state.currentWorkerPlans === null || !(this.state.currentWorkerPlans instanceof Array)) {
      return (<></>);
    }

    let listItems = this.objectToArray(this.computePlans());

    return (
      <>
        <div className="row">
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {'STT'}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('worker_name')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_assigned_total')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_assigned_totalP')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_ready')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_assigned')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_ck')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_nham')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_bong')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_kiemtra')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_loichosua')}
          </div>
          <div className="col-1 border-top border-left border-right border-light-gray table_header">
            {couterpart.translate('status_kim')}
          </div>
        </div>
        {listItems.map((item, index) => {
          if (index % 2 === 0) {
            return (
              <div className="row" key={item.workerId} style={{ backgroundColor: "lightblue" }}>
                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{index + 1}</label>
                </div>
                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{item.workerName}</label>
                </div>
                {this.renderValue(item.readyCount + item.assignedCount + item.ckCount + item.nhamCount + item.bongCount + item.kiemtraCount + item.loichosuaCount)}
                {this.renderValue(item.readyCountP + item.assignedCountP + item.ckCountP + item.nhamCountP + item.bongCountP + item.kiemtraCountP + item.loichosuaCountP)}
                {this.renderValue(item.readyCount)}
                {this.renderValue(item.assignedCount)}
                {this.renderValue(item.ckCount)}
                {this.renderValue(item.nhamCount)}
                {this.renderValue(item.bongCount)}
                {this.renderValue(item.kiemtraCount)}
                {this.renderValue(item.loichosuaCount)}
                {this.renderValue(item.kimCount)}
              </div>
            )
          } else {
            return (
              <div className="row" key={item.workerId} style={{ backgroundColor: "white" }}>
                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{index + 1}</label>
                </div>
                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{item.workerName}</label>
                </div>
                {this.renderValue(item.readyCount + item.assignedCount + item.ckCount + item.nhamCount + item.bongCount + item.kiemtraCount + item.loichosuaCount)}
                {this.renderValue(item.readyCountP + item.assignedCountP + item.ckCountP + item.nhamCountP + item.bongCountP + item.kiemtraCountP + item.loichosuaCountP)}
                {this.renderValue(item.readyCount)}
                {this.renderValue(item.assignedCount)}
                {this.renderValue(item.ckCount)}
                {this.renderValue(item.nhamCount)}
                {this.renderValue(item.bongCount)}
                {this.renderValue(item.kiemtraCount)}
                {this.renderValue(item.loichosuaCount)}
                {this.renderValue(item.kimCount)}
              </div>
            )
          }
        })
        }
      </>);
  }

  handleSkuChange(e) {
    var value = e.target.value;
    this.setState(prevState => ({
      sku: value
    }));
  }

  renderItemList() {
    let options = this.state.items !== undefined ? this.state.items : []
    return (
      <div className="col-2">
        <input type="text" name="font" size="16" className="selectBox3"
          list="skus"
          placeholder={couterpart.translate('work_order_code')}
          defaultValue={this.state.sku}
          onChange={this.handleSkuChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleSkuChange(e) }, 0); }} />
        <datalist id="skus">
          {options.map(x => <option value={x.sku} key={x.sku}>{x.sku}</option>)}
        </datalist>
      </div>
    );
  }

  handleFilterSelectChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      errorFilter: value
    });
  };

  renderErrorFilter() {
    let erroMode = WorkOrderUtil.getItem('supervext.errorFilter') === null || WorkOrderUtil.getItem('supervext.errorFilter') === undefined? 0: parseInt(WorkOrderUtil.getItem('supervext.errorFilter'));
    return (
      <>
        <select onChange={this.handleFilterSelectChange.bind(this)} className="select_margin" style={{ width: "100%", height: "50%", marginTo: "10px" }} 
          defaultValue={erroMode}>
          <option key="" value=""></option>
          <option key="WO_TOBE_FIXE_LOIXI" value={WO_TOBE_FIXE_LOIXI}>{couterpart.translate('wo_loixi')}</option>
          <option key="WO_TOBE_FIXE_LOITHO" value={WO_TOBE_FIXE_LOITHO}>{couterpart.translate('wo_loi_tho')}</option>
          <option key="WO_TOBE_FIXE_LOI_CATKHAC" value={WO_TOBE_FIXE_LOI_CATKHAC}>{couterpart.translate('wo_loi_catkhac')}</option>
          <option key="WO_TOBE_FIXE_ALL" value={WO_TOBE_FIXE_ALL}>{couterpart.translate('wo_loi_others')}</option>
        </select>&nbsp;&nbsp;
      </>
    );
  }

  render() {
    if (!AuthenticationService.isKhac() && !AuthenticationService.isSupervisor()) {
      return (<div>Unauthorized access.</div>);
    }

    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <br />
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className="col-12">
            <div className="row">
              <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-2">
                    <label><b>{couterpart.translate('order_date_from')}</b></label>:
                  </div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateFrom"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.fromDate)}
                        onChange={this.handleFromDateChange.bind(this)} /></div>
                  </div>
                  <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                  <div className="col-3">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateTo"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.toDate)}
                        onChange={this.handleToDateChange.bind(this)} /></div>
                  </div>
                </div>
              </div>
              <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                <div className="row">
                  <div className="col-3">
                    <input type="checkbox" value="1" checked={this.state.byDeadline === '1' ? true : false} onChange={this.handleByDeadlineClick.bind(this)} /> <label> {couterpart.translate('wo_by_deadline')} </label>
                  </div>
                  <div className="col-2">
                    <label><b>{couterpart.translate('order_date_from')}</b></label>
                  </div>
                  <div className="col-2">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateFrom"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.fromDeadlineDate)}
                        onChange={this.handleFromDeadlineDateChange.bind(this)} /></div>
                  </div>
                  <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                  <div className="col-2">
                    <div className="customDatePickerWidth">
                      <DatePicker name="orderDateTo"
                        dateFormat="MM/dd/yyyy hh:mm"
                        selected={WorkOrderUtil.convertToDate(this.state.toDeadlineDate)}
                        onChange={this.handleToDeadlineDateChange.bind(this)} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-2">
                {this.renderItemList()}
              </div>
              <div className="col-2 border-top border-left border-right border-bottom border-light-gray" style={{ paddingTop: "5px", marginBottom: "5px" }}>
                <input type="checkbox" value="1" onChange={this.handleSemiClick.bind(this)} checked={this.state.semi == 1 ? true : false} /> <label> {couterpart.translate('wo_semi')} </label>
                <input type="checkbox" value="1" style={{ marginLeft: "10px" }} onChange={this.handleIgnoreSemiClick.bind(this)} checked={this.state.ignoreSemi == 1 ? true : false} /> <label> {couterpart.translate('wo_ignore_semi')} </label>
              </div>
            </div>
            <div className="row" style={{ marginTop: "5px" }}>
              <div className="col-3">
                <div className="row">
                  <div className="col-1"><label style={{ width: "100%" }}><b>{couterpart.translate('work_order_status')}</b></label></div>
                  <div className="col-11">
                    <Multiselect
                      options={this.state.woStatusList}
                      selectedValues={this.state.selectedWoStatusList}
                      onSelect={this.onSelect.bind(this)}
                      onRemove={this.onRemove.bind(this)}
                      displayValue="name"
                      showCheckbox={true}
                    />
                  </div>
                </div>
              </div>
              <div className="col-1">
                <div className="row">
                  <div className="col-12">
                    <input type="text" defaultValue={this.state.orderNo} style={{ width: "100%" }}
                      placeholder={couterpart.translate('order_no')}
                      onChange={this.handleOrderNoChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }} />
                  </div>
                </div>
                <div className="row" style={{ marginTop: "5px" }}>
                  <div className="col-12">
                    <input type="text" defaultValue={this.state.pcode} style={{ width: "100%" }}
                      placeholder={couterpart.translate('shop_pcode')}
                      onChange={this.handlePcodeChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }} />
                  </div>
                </div>
                <div className="row" style={{ marginTop: "5px" }}>
                  <div className="col-12">
                    <input type="text" defaultValue={this.state.personalization} style={{ width: "100%" }}
                      placeholder={couterpart.translate('work_order_personalization')}
                      onChange={this.handlePersonalizationChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePersonalizationChange(e) }, 0); }} />
                  </div>
                </div>
                <div className="row" style={{ marginTop: "5px" }}>
                  <div className="col-12">
                    { this.renderErrorFilter() }
                  </div>
                </div>
              </div>
              <div className="col-1">
                <div className="row">
                  <div className="col-12">
                    {this.renderFilterWorkers()}
                  </div>
                </div>
                <div className="row" style={{ marginTop: "5px" }}>
                  <div className="col-12">
                    {this.renderSize()}
                  </div>
                </div>
                <div className="row" style={{ marginTop: "10px" }}>
                  <div className="col-12" style={{ marginTop: "5px" }}>
                    <input type="checkbox" value={1} checked={this.state.includeMau == 1 ? true : false} onChange={this.handleIncludeMauClick.bind(this)} /> &nbsp;{couterpart.translate('work_order_mau')}
                  </div>
                </div>
              </div>
              <div className="col-3 border-top border-left border-right border-bottom border-light-gray" style={{ paddingTop: "5px", marginBottom: "5px" }}>
                <div className="row">
                  <div className="col-6">
                    <input type="checkbox" value="1" onChange={this.handleNotPrintClick.bind(this)} checked={this.state.notPrint == 1 ? true : false} /> <label> {couterpart.translate('wo_no_print_worker')} </label>
                  </div>
                  <div className="col-6">
                    <input type="checkbox" value="1" onChange={this.handleNotPrintTailClick.bind(this)} checked={this.state.notPrintTail == 1 ? true : false} /> <label> {couterpart.translate('wo_no_print_tail')} </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <input type="checkbox" value="1" onChange={this.handleNotAssignedClick.bind(this)} checked={this.state.notAssigned == 1 ? true : false} /> <label> {couterpart.translate('wo_no_assigned_worker')} </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <label><b>{couterpart.translate('lbl_assign_info')}</b></label>:
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <DatePicker name="orderDateTo"
                      dateFormat="yyyy/MM/dd hh:mm"
                      selected={this.state.assignDate ? WorkOrderUtil.convertToDate(this.state.assignDate) : WorkOrderUtil.convertToDate("2020/01/01")}
                      onChange={this.handleAssignDateChange.bind(this)} />
                  </div>
                  <div className="col-6">
                    <input type="number" style={{ width: '70px', marginLeft: '2px' }}
                      placeholder={couterpart.translate('lbl_assign_count')}
                      onChange={this.handleAssignCountChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleAssignCountChange(e) }, 0); }} />
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    {this.renderDealine()}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    {this.renderReprintTail()}
                  </div>
                  <div className="col-12">
                    {this.renderIncident()}
                  </div>
                </div>
              </div>
              <div className="col-1">
                <div className="row">
                  <div className="col-12">
                    <button className="myButton"
                      onClick={this.onFilter.bind(this)}>
                      <FaFilter color={ICON_COLOR} />
                      &nbsp;{couterpart.translate('button_filter')}
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <button className="myButton"
                      onClick={this.onTestMsg.bind(this)}>
                      <FaFilter color={ICON_COLOR} />
                      &nbsp;Test MSG
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
          <div className="col-2">
            {this.renderReadyButton()}
          </div>
          <div className="col-1">{this.renderSemi()}</div>
          <div className="col-1">
            <button className="myButton"
              onClick={this.changeSemi.bind(this)}>
              <MdImportExport color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_semi')}
            </button>
          </div>
          <div className="col-1">
            <button className="myButton"
              onClick={this.exportExcel.bind(this)}>
              <MdImportExport color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_export')}
            </button>
          </div>
          <div className="col-1">
            <button className="myButton"
              onClick={this.printTails.bind(this)}>
              <MdImportExport color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_print_tail')}
            </button>
          </div>
          <div className="col-1">{this.renderWorkers()}</div>
          <div className="col-2">
            {this.renderChangeWorkerButton()}
          </div>
          <div className="col-1">
            {this.renderChotWorkerButton()}
          </div>
          <div className="col-1">
            {this.renderResolveIncidentButton()}
          </div>
          <div className="col-1">
            <button className="myButton"
              onClick={this.showWorkerPlan.bind(this, 1)}>
              <MdImportExport color={ICON_COLOR} />
              &nbsp;{couterpart.translate('button_worker_plan')}
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <ReactTable
              manual
              NoDataComponent={() => null}
              previousText={"<"}
              nextText={">"}
              onPageChange={pageIndex => {
                this.setState({ selectedPage: pageIndex }, () => {
                  this.filterOrdersBy()
                })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                this.setState({ page: pageIndex, pageSize: pageSize });
              }}
              onSortedChange={sorted => {
                let sortType = this.state.sortType === 'desc' ? 'asc' : 'desc';
                this.setState({
                  sortBy: sorted[0].id,
                  sortType: sortType
                }, () => {
                  this.filterOrdersBy()
                });
              }}
              data={this.state.workOrders}
              loading={this.state.loading}
              pages={this.state.pages}
              columns={this.state.columns}
              defaultPageSize={20}
              showPageSizeOptions={true}
              pageSizeOptions={[3, 5, 10, 20]}
            />
          </div>
        </div>
        <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
        <Modal show={this.state.show3} onHide={this.handleClose3.bind(this)} backdrop="static" dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title">
          <Modal.Header closeButton>
            <Modal.Title>{couterpart.translate("msg_title_worker_plan")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">&nbsp;</div>
            <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px' }}>
              <div className="col-12">
                <div className="row">
                  <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                    <div className="row">
                      <div className="col-2">
                        <label><b>{couterpart.translate('order_date_from')}</b></label>:
                      </div>
                      <div className="col-3">
                        <div className="customDatePickerWidth">
                          <DatePicker name="orderDateFrom4U"
                            dateFormat="MM/dd/yyyy hh:mm"
                            selected={WorkOrderUtil.convertToDate(this.state.fromDate4U)}
                            onChange={this.handleFromDateChange4U.bind(this)} /></div>
                      </div>
                      <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                      <div className="col-3">
                        <div className="customDatePickerWidth">
                          <DatePicker name="orderDateTo"
                            dateFormat="MM/dd/yyyy hh:mm"
                            selected={WorkOrderUtil.convertToDate(this.state.toDate4U)}
                            onChange={this.handleToDateChange4U.bind(this)} /></div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
                    <div className="row">
                      <div className="col-3">
                        <input type="checkbox" value="1" checked={this.state.byDeadline4U === '1' ? true : false} onChange={this.handleByDeadlineClick4U.bind(this)} /> <label> {couterpart.translate('wo_by_deadline')} </label>
                      </div>
                      <div className="col-2">
                        <label><b>{couterpart.translate('order_date_from')}</b></label>
                      </div>
                      <div className="col-2">
                        <div className="customDatePickerWidth">
                          <DatePicker name="orderDateFrom4U"
                            dateFormat="MM/dd/yyyy hh:mm"
                            selected={WorkOrderUtil.convertToDate(this.state.fromDeadlineDate4U)}
                            onChange={this.handleFromDeadlineDateChange4U.bind(this)} /></div>
                      </div>
                      <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
                      <div className="col-2">
                        <div className="customDatePickerWidth">
                          <DatePicker name="orderDateTo4U"
                            dateFormat="MM/dd/yyyy hh:mm"
                            selected={WorkOrderUtil.convertToDate(this.state.toDeadlineDate4U)}
                            onChange={this.handleToDeadlineDateChange4U.bind(this)} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-2 border-top border-left border-right border-bottom border-light-gray" style={{ paddingTop: "5px", marginBottom: "5px" }}>
                    <input type="checkbox" value="1" onChange={this.handleSemiClick4U.bind(this)} checked={this.state.semi4U == 1 ? true : false} /> <label> {couterpart.translate('wo_semi')} </label>
                    <input type="checkbox" value="1" style={{ marginLeft: "10px" }} onChange={this.handleIgnoreSemiClick4U.bind(this)} checked={this.state.ignoreSemi4U == 1 ? true : false} /> <label> {couterpart.translate('wo_ignore_semi')} </label>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "5px" }}>
                  <div className="col-3">
                    <div className="row">
                      <div className="col-1"><label style={{ width: "100%" }}><b>{couterpart.translate('work_order_status')}</b></label></div>
                      <div className="col-11">
                        <Multiselect
                          options={this.state.woStatusList}
                          selectedValues={this.state.selectedWoStatusList4U}
                          onSelect={this.onSelect4U.bind(this)}
                          onRemove={this.onRemove4U.bind(this)}
                          displayValue="name"
                          showCheckbox={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-1">
                    <div className="row">
                      <div className="col-12">
                        <input type="text" defaultValue={this.state.orderNo4U} style={{ width: "100%" }}
                          placeholder={couterpart.translate('order_no')}
                          onChange={this.handleOrderNoChange4U.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange4U(e) }, 0); }} />
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "5px" }}>
                      <div className="col-12">
                        <input type="text" defaultValue={this.state.pcode4U} style={{ width: "100%" }}
                          placeholder={couterpart.translate('shop_pcode')}
                          onChange={this.handlePcodeChange4U.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange4U(e) }, 0); }} />
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: "5px" }}>
                      <div className="col-12">
                        <input type="text" defaultValue={this.state.personalization4U} style={{ width: "100%" }}
                          placeholder={couterpart.translate('work_order_personalization')}
                          onChange={this.handlePersonalizationChange4U.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePersonalizationChange4U(e) }, 0); }} />
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    {this.renderDealine4U()}
                  </div>
                  <div className="col-1">
                    <button className="myButton"
                      onClick={this.onFilter4U.bind(this)}>
                      <FaFilter color={ICON_COLOR} />
                      &nbsp;{couterpart.translate('button_filter')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-1">{this.renderPlanWorkers()}</div>
              <div className="col-2">
                <button className="myButton"
                  onClick={this.planWorker.bind(this, 1)}>
                  <MdImportExport color={ICON_COLOR} />
                  &nbsp;{couterpart.translate('button_change_worker_only')}
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <ReactTable
                  manual
                  NoDataComponent={() => null}
                  previousText={"<"}
                  nextText={">"}
                  onPageChange={pageIndex => {
                    this.setState({ selectedPage4U: pageIndex }, () => {
                      this.filterUnassignedOrdersBy()
                    })
                  }}
                  onPageSizeChange={(pageSize, pageIndex) => {
                    this.setState({ page4U: pageIndex, pageSize4U: pageSize });
                  }}
                  onSortedChange={sorted => {
                    let sortType = this.state.sortType === 'desc' ? 'asc' : 'desc';
                    this.setState({
                      sortBy4U: sorted[0].id,
                      sortType4U: sortType
                    }, () => {
                      this.filterUnassignedOrdersBy()
                    });
                  }}
                  data={this.state.workOrders4U}
                  loading={this.state.loading4U}
                  pages={this.state.pages4U}
                  columns={this.state.columns4U}
                  defaultPageSize={10}
                  showPageSizeOptions={true}
                  pageSizeOptions={[3, 5, 10, 20]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                {this.renderWorkerPlans()}
              </div>
            </div>
            <div className="row">
              <dov className="col-12">

              </dov>
            </div>
            <div className="row">&nbsp;</div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose3.bind(this)}>Cancel</Button>
            <Button variant="primary" onClick={this.onSave.bind(this)}>OK</Button>
          </Modal.Footer>
        </Modal>

        <Dialog ref={(component) => { this.dialog = component }} />
        {this.renderWorkOrderDialog()}
      </div>
    )
  }
}
export default withRouter(SuperList);